export default __webpack_public_path__ + "static/media/icon-instagram.b5641a48.svg";